<template>
<div>
<v-list two-line>
    <v-list-item
        v-for="item in items"
        :key="item.meta.listKey"
       
        :title="item.meta.listHover"
        @click="$emit('click', item)"
    >
        <v-list-item-avatar>
        <v-icon>{{item.meta.listIcon || 'folder'}}</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
        <v-list-item-title>{{ item.meta.listTitle }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.meta.listDetails }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
        <v-btn icon ripple>
            <v-icon color="grey lighten-1">info</v-icon>
        </v-btn>
        </v-list-item-action>
    </v-list-item>
</v-list>
</div>
</template>

<script>

import FireData from '../data/FireData'
import DataHelpers from '../helpers/DataHelpers'


export default {
    data() {
        return {
            layout: {
                title: 'stamp.firstName',
                subtitle: 'stamp.date',
            },
        }
    },
    
    props: {
        items: Array,
    },

    computed: {

 
    },

    methods: {
        stringify(obj){
            return JSON.stringify(obj)
        },
 

    },

    watch: {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// GenericList.vue?4ece0cca